import AsyncStorage from '@react-native-async-storage/async-storage';
import type { InboxProviderId } from '@/services/inboxSync';

const keyForUser = (userId: string) => `@tripflow_last_inbox_provider_${userId}`;

export const setLastUsedInboxProvider = async (userId: string, provider: InboxProviderId) => {
  try {
    await AsyncStorage.setItem(keyForUser(userId), provider);
  } catch (error) {
    console.debug('[LastInboxProvider] Failed to save provider', error);
  }
};

export const getLastUsedInboxProvider = async (userId: string): Promise<InboxProviderId | null> => {
  try {
    const value = await AsyncStorage.getItem(keyForUser(userId));
    if (value === 'gmail' || value === 'outlook' || value === 'icloud') {
      return value;
    }
    return null;
  } catch (error) {
    console.debug('[LastInboxProvider] Failed to read provider', error);
    return null;
  }
};

